/* global axios */
import { accountIdFromRoute, msBaseUrl } from './microservicos';

const baseUrl = () => msBaseUrl('calendar', accountIdFromRoute());

export const googleCalendarAPI = {
  getOAuthConfig() {
    return axios.get(`${baseUrl()}/oauth/config`);
  },
  saveOAuthConfig(data) {
    return axios.post(`${baseUrl()}/oauth/config`, data);
  },
  getAuthorizationUrl() {
    return axios.get(`${baseUrl()}/oauth/authorize`);
  },
  getCalendars() {
    return axios.get(`${baseUrl()}/calendar/list`);
  },
  getEvents(calendarId, startDate, endDate) {
    return axios.get(`${baseUrl()}/calendar/${calendarId}/events`, {
      params: { startDate, endDate },
    });
  },
  createEvent(calendarId, eventData) {
    return axios.post(`${baseUrl()}/calendar/${calendarId}/events`, eventData);
  },
  updateEvent(calendarId, eventId, eventData) {
    return axios.put(
      `${baseUrl()}/calendar/${calendarId}/events/${eventId}`,
      eventData
    );
  },
  deleteEvent(calendarId, eventId) {
    return axios.delete(
      `${baseUrl()}/calendar/${calendarId}/events/${eventId}`
    );
  },
};
